module.exports = __webpack_public_path__ + "img/6.69215e7b.jpg";